import { useEffect, type Dispatch, type SetStateAction } from "react";
import { releaseComposerAttachmentUrls } from "@/lib/composer-attachment";
import type { ImageAttachment } from "./image-preview-strip";

export function useComposerAttachmentLifetime(
  attachments: ImageAttachment[],
  setAttachments: Dispatch<SetStateAction<ImageAttachment[]>>,
) {
  useEffect(() => {
    releaseComposerAttachmentUrls(
      setAttachments,
      new Set(attachments.map((attachment) => attachment.url)),
    );
  }, [attachments, setAttachments]);
  useEffect(
    () => () => releaseComposerAttachmentUrls(setAttachments),
    [setAttachments],
  );
}
